/**
 * FirebaseProvider Component
 *
 * This component initializes Firebase when the app loads and provides
 * Firebase context to the rest of the application.
 */

import { useEffect, useState, ReactNode } from 'react';
import { initializeFirebase, getFirebaseAnalytics, isFirebaseConfigured } from '@/lib/firebase';

interface FirebaseProviderProps {
  children: ReactNode;
}

export function FirebaseProvider({ children }: FirebaseProviderProps) {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Check if Firebase is configured
    if (!isFirebaseConfigured()) {
      console.log('Firebase configuration not found. Skipping initialization.');
      setIsInitialized(true);
      return;
    }

    // Initialize Firebase
    const app = initializeFirebase();

    if (app) {
      // Initialize Analytics if available
      getFirebaseAnalytics().then((analytics) => {
        if (analytics) {
          console.log('Firebase Analytics is ready');
        }
      });

      setIsInitialized(true);
    } else {
      console.warn('Failed to initialize Firebase');
      setIsInitialized(true);
    }
  }, []);

  // Don't render children until Firebase is initialized (or skipped)
  // This prevents race conditions with Firebase-dependent code
  if (!isInitialized) {
    return null;
  }

  return <>{children}</>;
}
